export function generateImageUrl(imageUrl, loggedUser) {
  if (imageUrl) {
    return `${imageUrl}`;
  } else if (loggedUser?.profilePic) {
    return `${loggedUser.profilePic}`;
  }
  return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTga82Zqlb6VqnCZcxG2ur7hI6Fw8aJTtJLvDhiunx0AxCd6j8lmMVt1cIA-Tw-S3xV754&usqp=CAU';
}
